var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.083,
    height: 35.083,
    viewBox: "0 0 35.083 35.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_1031827",
    transform: "translate(-7.5 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9069",
    "data-name": "Path 9069",
    d: "M25.042,7.5A17.542,17.542,0,1,0,42.583,25.042,17.542,17.542,0,0,0,25.042,7.5Zm0,33.019A15.478,15.478,0,1,1,40.519,25.042,15.478,15.478,0,0,1,25.042,40.519Z",
    fill: "#cf0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9070",
    "data-name": "Path 9070",
    d: "M46.175,30.119a1.032,1.032,0,0,0-1.461,0l-6.567,6.567-6.567-6.567a1.033,1.033,0,0,0-1.461,1.461l6.567,6.567-6.567,6.567a1.033,1.033,0,1,0,1.461,1.461l6.567-6.567,6.567,6.567a1.033,1.033,0,1,0,1.461-1.461l-6.567-6.567,6.567-6.567a1.032,1.032,0,0,0,0-1.461Z",
    transform: "translate(-13.106 -13.105)",
    fill: "#cf0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete-icon.8ca4fbd726d0de62d8902b5dda557544.svg";
export { ForwardRef as ReactComponent };